import External from "./external";
import {
  responseHandler,
  errorHandler,
  downloadResponseHandler,
} from "../util";
import { toaster } from "evergreen-ui";

export const login = (data) => async (dispatch) => {
  try {
    const res = await External.login(data);
    await responseHandler(dispatch, res, "SET_LOGIN_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const toggleAuthStatus = () => (dispatch) => {
  dispatch({ type: "SET_AUTH_STATUS" });
};

export const getDashboardData = (data) => async (dispatch) => {
  try {
    const res = await External.getDashboardData(data);

    await responseHandler(dispatch, res, "SET_DASHBOARD_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getActivities = () => async (dispatch) => {
  try {
    const res = await External.getActivities();
    await responseHandler(dispatch, res, "SET_ACTIVITY_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getAvailability = (data) => async (dispatch) => {
  try {
    const res = await External.getAvailability(data);
    await responseHandler(dispatch, res, "SET_AVAILABILITY_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getEscalationMatrix = (data) => async (dispatch) => {
  try {
    const res = await External.getEscalationMatrix(data);
    await responseHandler(dispatch, res, "SET_ESCALATION_MATRIX_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const switchClub = (data) => async (dispatch) => {
  try {
    const res = await External.switchClub(data);

    await responseHandler(dispatch, res, "SET_SWITCH_CLUB_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getSlotUnavailabilityStatus = (data) => async (dispatch) => {
  try {
    const res = await External.getSlotUnavailabilityStatus(data);
    await responseHandler(dispatch, res, "SET_SLOT_UNAVAILABILITY_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const updateCartData = (data) => (dispatch) => {
  dispatch({ type: "SET_CART_DATA", data });
};

export const getCountryCodes = () => async (dispatch) => {
  try {
    const res = await External.getCountryCodes();
    await responseHandler(dispatch, res, "SET_COUNTRY_CODES_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getCustomerDetails = (data) => async (dispatch) => {
  try {
    const res = await External.getCustomerDetails(data);
    await responseHandler(dispatch, res, "SET_CUSTOMER_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const confirmBooking = (data) => async (dispatch) => {
  try {
    const res = data.isPatternBooking
      ? await External.confirmBulkBooking(data)
      : await External.confirmBooking(data);
    await responseHandler(dispatch, res, "SET_BOOKING_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getPriceClassDetails = () => async (dispatch) => {
  try {
    const res = await External.getPriceClassDetails();
    await responseHandler(dispatch, res, "SET_PRICE_CLASS_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getPricingDetails = (data) => async (dispatch) => {
  try {
    const res = await External.getPricingDetails(data);
    await responseHandler(dispatch, res, "SET_PRICING_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const changeUserPassword = (data) => async (dispatch) => {
  try {
    const res = await External.changeUserPassword(data);
    await responseHandler(dispatch, res, "SET_CHANGE_PASSWORD_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const createUser = (data) => async (dispatch) => {
  try {
    const res = await External.createUser(data);
    await responseHandler(dispatch, res, "SET_DESK_USER_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const searchBookings =
  (data, type, previousSearchData = []) =>
  async (dispatch) => {
    try {
      let res = await External.searchBookings(data, type);
      if (res.data.bookingDetails || res.data.patternBookings) {
        let newBooking =
          type === "bulk" ? res.data.patternBookings : res.data.bookingDetails;

        res = Object.assign({}, res, {
          data: {
            ...res.data,
            bookingDetails: [...previousSearchData, ...newBooking],
          },
        });
        console.log({ res });
      }
      await responseHandler(dispatch, res, "SET_BOOKING_SEARCH_DATA");
    } catch (err) {
      await errorHandler(dispatch, err);
    }
  };

export const getBookingTransactions = (data) => async (dispatch) => {
  try {
    const res = await External.getBookingTransactions(data);
    await responseHandler(dispatch, res, "SET_BOOKING_TRANSACTIONS_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const downloadReport = (data, type) => async (dispatch) => {
  try {
    let res;
    if (type === "booking") {
      res = await External.downloadBookingReport(data, type);
      console.log({ res });
    } else if (type === "cancellation") {
      res = await External.downloadCancellationReport(data, type);
    }
    await downloadResponseHandler(
      res,
      `${type}-report.xlsx`,
      "No reports found for the selected dates"
    );
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const updateBooking = (data) => async (dispatch) => {
  try {
    const res = await External.updateBooking(data);
    await responseHandler(dispatch, res, "SET_PAY_NOW_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const transactionCode = () => async (dispatch) => {
  try {
    const res = await External.transactionCode();
    await responseHandler(dispatch, res, "SET_TRANSACTION_CODES_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const rescheduleBookingVerify = (data) => async (dispatch) => {
  try {
    const res = await External.rescheduleBookingVerify(data);
    await responseHandler(dispatch, res, "SET_RESCHEDULE_VERIFY_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const reschedulePrice = (data) => async (dispatch) => {
  try {
    const res = await External.reschedulePrice(data);
    await responseHandler(dispatch, res, "SET_RESCHEDULE_PRICE_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const rescheduleBooking = (data) => async (dispatch) => {
  try {
    const res = await External.rescheduleBooking(data);
    await responseHandler(dispatch, res, "SET_RESCHEDULE_BOOKING_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const printBookingReceipt = (data) => async (dispatch) => {
  try {
    const res = await External.printBookingReceipt(data);
    await downloadResponseHandler(
      res,
      `bookingReceipt.pdf`,
      "No details found "
    );
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const printBookingStatement = (data) => async (dispatch) => {
  try {
    const res = await External.printBookingStatement(data);
    await downloadResponseHandler(
      res,
      `bookingStatement.pdf`,
      "No statement found "
    );
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getBooking = (data) => async (dispatch) => {
  try {
    const res = await External.getBooking(data);
    await responseHandler(dispatch, res, "SET_BOOKING_DETAILS_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getCourtList = (data) => async (dispatch) => {
  try {
    const res = await External.getCourtList(data);
    await responseHandler(dispatch, res, "SET_COURT_LIST_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const verifySlotsAvailability = (data) => async (dispatch) => {
  try {
    const res = await External.verifySlotsAvailability(data);
    await responseHandler(dispatch, res, "SET_VERIFY_SLOTS_AVAILABILITY_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getPatternBookingSlots = (data) => async (dispatch) => {
  try {
    const res = await External.getPatternBookingSlots(data);
    await responseHandler(dispatch, res, "SET_PATTERN_BOOKING_SLOTS_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const editPrice = (data) => async (dispatch) => {
  try {
    const res = await External.editPrice(data);

    await responseHandler(dispatch, res, "SET_EDIT_PRICE_DATA");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const oneSignalUpdate = (data) => async (dispatch) => {
  try {
    const res = await External.oneSignalUpdate(data);

    if (res.data.requestStatus === 1) {
      localStorage.setItem("onesignal", data.onesignalId);
      localStorage.removeItem("onesignalId");
    }
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const enableReschedule = (data) => async (dispatch) => {
  try {
    const res = await External.enableReschedule(data);

    await responseHandler(dispatch, res, "SET_ENABLE_RESCHEDULE");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const markNoShow = (data) => async (dispatch) => {
  try {
    const res = await External.markNoShow(data);

    await responseHandler(dispatch, res, "SET_NOSHOW");
  } catch (err) {
    await errorHandler(dispatch, err);
  }
};

export const getNotifications =
  (data, previousNotificationData = []) =>
  async (dispatch) => {
    try {
      let res = await External.getNotifications(data);

      if (res && res.data && res.data.data.notifications) {
        res = Object.assign({}, res, {
          data: {
            ...res.data.data,
            notifications: [
              ...previousNotificationData,
              ...res.data.data.notifications,
            ],
          },
        });
      }

      await responseHandler(dispatch, res, "SET_NOTIFICATION_DATA");
    } catch (err) {
      console.log({ err });
      await errorHandler(dispatch, err);
    }
  };

export const syncAvailability = () => async (dispatch) => {
  try {
    const res = await External.syncAvailability();
    if (res?.data?.requestStatus === 1) {
      toaster.success(res?.data?.message);
    } else {
      toaster.danger(res?.data?.message);
    }
  } catch (err) {
    toaster.danger("Some Error Occoured");
    console.log(err);
  }
};

export const bookingCheckIn = (data) => async (dispatch) => {
  try {
    const res = await External.bookingCheckIn(data);
    if (res?.data?.requestStatus === 1) {
      toaster.success(res?.data?.message);
    } else {
      toaster.danger(res?.data?.message);
    }
    return res.data;
  } catch (err) {
    toaster.danger("Some Error Occoured");
    console.log(err);
  }
};

export const getCategoriesList = async (data) => {
  try {
    const res = await External.getCategoriesList({ eventId: data });

    return res?.data;
  } catch (err) {
    toaster.danger("Some Error Occoured");
    console.log(err);
  }
};

export const getEventBookingList = async (data) => {
  try {
    const res = await External.getEventBookingList(data);
    return res;
  } catch (err) {
    toaster.danger("Some Error Occoured");
    console.log(err);
  }
};

export const getEvents = async () => {
  try {
    const res = await External.getEvents();

    return res?.data;
  } catch (err) {
    toaster.danger("Some Error Occoured");
    console.log(err);
  }
};
